import { mapState } from 'vuex';
import IconGrabBag from '~/components/icon/IconGrabBag.vue';
import IconGrabLorry from '~/components/icon/IconGrabLorry.vue';
import IconSkip from '~/components/icon/IconSkip.vue';
import IconTruck from '~/components/icon/IconTruck.vue';

export default {
    async fetch() {
        await this.$store.dispatch('services/get');
    },
    computed: {
        ...mapState(['services']),
        servicesWithIcons() {
            if (!this.services) {
                return [];
            }
            const services = [];
            this.services.data.forEach((checkService) => {
                const service = { ...checkService };
                switch (service.icon) {
                    case 'IconSkip':
                    default:
                        service.icon = IconSkip;
                        break;
                    case 'IconGrabBag':
                        service.icon = IconGrabBag;
                        break;
                    case 'IconGrabLorry':
                        service.icon = IconGrabLorry;
                        break;
                    case 'IconTruck':
                        service.icon = IconTruck;
                        break;
                }
                services.push(service);
            });
            return services;
        },
    },
};
